import type { FeatureListProps } from 'components/PageWrappers/AdDetails/components/FeatureListGrid/FeatureList/FeatureList.typed';
import React from 'react';
import { BulletedList } from 'components/ToolkitV2/BulletedList/BulletedList';
import * as Styled from 'components/PageWrappers/AdDetails/components/FeatureListGrid/FeatureList/FeatureList.styled';

export const FeatureList = (props: FeatureListProps) => {
  const { children, title } = props;
  return (
    <div>
      <Styled.Title>{title}</Styled.Title>
      <BulletedList>{children}</BulletedList>
    </div>
  );
};
